import type React from "react";
import { useState } from "react";
import { HiEye, HiEyeOff } from "react-icons/hi";

export interface FormFieldProps {
  id: string;
  name: string;
  label: string;
  type?: "text" | "email" | "password" | "number";
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string | undefined;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  helpText?: string;
}

export function FormField({
  id,
  name,
  label,
  type = "text",
  value,
  onChange,
  error,
  required = false,
  placeholder,
  disabled = false,
  helpText,
}: FormFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;

  return (
    <div>
      <label htmlFor={id} className="block label">
        {required && <span className="text-red-500 ml-1">* </span>}
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          name={name}
          type={inputType}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          disabled={disabled}
          className={`mt-1 block w-full px-3 py-2 bg-surface border rounded-md text-secondary-200 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 disabled:bg-gray-800 disabled:cursor-not-allowed ${
            error ? "border-red-500" : "border-gray-800"
          }`}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-secondary-200 hover:text-primary-500 focus:outline-none"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <HiEyeOff className="h-5 w-5" role="img" aria-hidden="true" />
            ) : (
              <HiEye className="h-5 w-5" role="img" aria-hidden="true" />
            )}
          </button>
        )}
      </div>
      {helpText && !error && <p className="caption mt-1 text-sm">{helpText}</p>}
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
}
